var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('uni-button',{attrs:{"disabled":_vm.isDisable}},[(_vm.isDisable)?_c('div',[_c('uni-circular-loader')],1):_c('div',[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }